import { useState } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowNotification } from "../Common/showNotification";

function useGetFakeAIImage() {
  const [fetchWrapper] = useFetch();
  const showNotification = useShowNotification();

  const [abortController, setAbortController] = useState(new AbortController());

  const getFakeAIImage = (
    image_id,
    timeout_duration,
    plates,
    selectedPlateIndex,
    getFakePlates
  ) => {
    let timeout_id = setTimeout(() => {
      //Abort summary, energy consumption distribution, and device list's fetch request
      abortController.abort("");
      //Assign a new abort controller
      setAbortController(new AbortController());
    }, timeout_duration * 1000);
    fetchWrapper({
      endpoint_url: "image/getFakeAIImage",
      abort_controller: abortController,
      params: {
        image_id: image_id,
        timeout: timeout_duration,
      },
      onSuccess: (fetch_output) => {
        clearTimeout(timeout_id);
        if (!("error" in fetch_output)) {
          let data = fetch_output["data"];
          let cloned_plates = JSON.parse(JSON.stringify(plates));
          cloned_plates[selectedPlateIndex] = data;

          getFakePlates(cloned_plates);
        } else {
          showNotification({
            message: "Unexpected error.",
            description: "Please try again leter or contact admin.",
          });
        }
      },
      onResponseError: () =>
        showNotification({
          message: "Failed to analyze image.",
          description: "Please try again later or try on a new image.",
        }),
      onFetchError: () => {
        showNotification({
          message: "Failed to analyze image.",
          description: "Please try again later or try on a new image.",
        });
      },
    });
  };

  return { getFakeAIImage };
}

export default useGetFakeAIImage;
